// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"textBlock_textBlock__h9lP1","noMargins":"textBlock_noMargins__2UZKJ"};